import { Link, useRouteError } from "react-router-dom";

import { Button } from "shared/ui/button";

export const ErrorPage = () => {
  const error = useRouteError();

  console.log(error);
  console.log("Error:: ", error, "eeeeeeee");

  if (
    error instanceof Error &&
    (error.message.includes("dynamically imported module") ||
      error.message.includes("Importing a module script failed"))
  ) {
    window.location.reload();

    return null;
  }

  return (
    <div
      className="flex grow flex-col items-center justify-center"
      id="error-page"
    >
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred</p>

      <Button as={Link} className="mt-6" to="/">
        Go to home page
      </Button>
    </div>
  );
};
